export default function Callback() {
  return (
    <div className="page-shell flex flex-col items-center justify-center px-6 text-secondary">
      <div className="ui-card max-w-md w-full p-8 text-center">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-success/10 text-3xl text-success">
          🔄
        </div>
        <h1 className="mb-3 text-2xl font-bold text-secondary">
          Connecting to TikTok...
        </h1>
        <p className="mb-6 text-sm leading-relaxed text-textMuted">
          DeCipher is securely authorizing your brand channel credentials. This window will update automatically once synchronization completes.
        </p>
        <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 text-xs text-textMuted">
          <span className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></span>
          Awaiting Secure Token Exchange
        </div>
      </div>
    </div>
  );
}